import Axios from 'axios';

// const api_url = window.location.host;
// const host = ':8071'
Axios.defaults.baseURL = 'http://' + 'shop.szpdc.com';
// Axios.defaults.baseURL = 'http://' + '172.16.14.11' + ':8069';
// Axios.defaults.baseURL = 'http://' + '172.16.7.3' + ':8069';

// 获取登陆Token
export function getToken () {
  const data = {
    'grant_type': 'access_token',
    'timestamp': '2020-03-23 11:15:40',
    'username': 'tomorinao',
    'password': 'CF0476C0D76CA90AF1F81E056414622F',
    'sign': 'lixunluoqunimadeba'
  };
  return Axios.post('/szec/access_token', data).then((data) => data.data);
}

export function getChannel () {
  return Axios.post('/api/shop/channel').then(data => data.data);
}

export function toRegister (data) {
  return Axios.post('/api/shop/register', data).then(data => data.data);
}

export function getAccessCode (data) {
  return Axios.post('/api/shop/getAccessCode', data).then(data => data.data);
}

export function toLogin (data) {
  return Axios.post('/api/shop/login', data).then(data => data.data.result);
}

export function getBanner (data) {
  return Axios.post('/api/shop/banner', data).then(data => data.data);
}

export function getDetails (data) {
  return Axios.post('/api/shop/details', {'sku': data}).then(data => data.data);
}

export function getSearch (data) {
  return Axios.post('/api/shop/search', {'name': data}).then(data => data.data.result);
}

export function getShopCar (data) {
  return Axios.post('/api/shop/showCart', {'partner_id': data}).then(data => data.data.result);
}

export function getShopOrder (data) {
  return Axios.post('/api/shop/showOrder', {'partner_id': data}).then(data => data.data.result);
}

export function getShopAddress (data) {
  return Axios.post('/api/shop/showAddress', {'user_id': data}).then(data => data.data.result);
}

export function addToCart (data) {
  return Axios.post('/api/shop/AddToCart', data).then(data => data.data.result);
}

export function addToAddress (data) {
  return Axios.post('/api/shop/AddToAddress', data).then(data => data.data.result);
}

export function createOrder (data) {
  return Axios.post('/api/shop/createOrder', data).then(data => data.data);
}

export function getOrder (data) {
  return Axios.post('/api/shop/selectOrder', data).then(data => data.data);
}

export function getGoodsList (data) {
  return Axios.post('/api/shop/goodslist', data).then(data => data.data);
}

export function resetPassword (data) {
  return Axios.post('/api/shop/resetPassword', data).then(data => data.data);
}

export function updateAddress (data) {
  return Axios.post('/api/shop/updateAddress', data).then(data => data.data.result);
}

export function deleteAddress (data) {
  return Axios.post('/api/shop/deleteAddress', data).then(data => data.data.result);
}

export function getShopInvoice (data) {
  return Axios.post('/api/shop/showInvoice', {'user_id': data}).then(data => data.data.result);
}

export function addToInvoice (data) {
  return Axios.post('/api/shop/AddToInvoice', data).then(data => data.data.result);
}

export function updateInvoice (data) {
  return Axios.post('/api/shop/updateInvoice', data).then(data => data.data.result);
}

export function deleteInvoice (data) {
  return Axios.post('/api/shop/deleteInvoice', data).then(data => data.data.result);
}




// WEBPACK FOOTER //
// ./src/api/api.js